var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.973,
    height: 12.141,
    viewBox: "0 0 6.973 12.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-right",
    d: "M-2.789-11.211a.3.3,0,0,1,.465,0L3.391-5.469a.256.256,0,0,1,0,.438L-2.324.711a.3.3,0,0,1-.465,0L-3.336.164a.281.281,0,0,1,0-.465L1.613-5.25-3.336-10.2a.281.281,0,0,1,0-.465Z",
    transform: "translate(3.459 11.32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.83c212611bde3ded77ee36f57f0b7093.svg";
export { ForwardRef as ReactComponent };